import PropTypes from 'prop-types'

import classes from './ProgramReportCard.module.scss'
import { ReactComponent as AccountIcon } from '../../../assets/images/common/icons/account-icon.svg'

// Presentational report card. The whole card is a native button (no nested
// interactive element) that delegates to onDownload; the parent tab owns the
// generating/downloading state and its loading view.
const ProgramReportCard = ({ reportType, title, description, onDownload }) => (
  <button
    type='button'
    className={classes.card}
    onClick={() => onDownload(reportType)}
  >
    <span className={classes.info}>
      <AccountIcon className={classes.icon} />
      <span className={classes.text}>
        <span className={classes.title}>{title}</span>
        <span className={classes.description}>{description}</span>
      </span>
    </span>
    <span className={classes.downloadAction}>Download</span>
  </button>
)

ProgramReportCard.propTypes = {
  reportType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
}

export default ProgramReportCard
